import React, { useState } from 'react'
import { ContextualAlert } from '@paypalcorp/pp-react'
import { default as Lightbox } from 'react-image-lightbox'
import clx from 'classnames'

import { ExpandButton } from './icons/ExpandButton'
import { DownloadButton } from './icons/DownloadButton'
import { Checkmark } from './icons/Checkmark'
import withAnalytics from '../../utils/withAnalytics'

import './imageContainer.css'

const IconButton = ({ Icon, onClick }) => {
  const [success, setSuccess] = useState(false)

  const triggerSuccess = () => {
    setSuccess(true)

    setTimeout(() => {
      setSuccess(false)
    }, 2000)
  }

  return (
    <button
      className={clx('imageContainerBtn', {
        imageContainerBtnSuccess: success,
      })}
      onClick={() => {
        triggerSuccess()
        onClick()
      }}
    >
      {success ? <Checkmark /> : <Icon />}
    </button>
  )
}

export const ImageContainer = ({
  src,
  fileName,
  caption,
  className = '',
  section = '',
  fpti,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga

  const downloadImage = () => {
    if (fptiData) {
      fpti.record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.page,
          e: 'cl',
          link: `download_${fileName}_${section}`,
        },
      })
    }
    if (gaData) {
      gaData('send', 'event', `download_${fileName}_${section}`, 'click', {})
    }

    fetch(src)
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        // the filename you want
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(() => console.log('An error occurred downloading your file'))
  }

  const expandImage = () => {
    if (fptiData) {
      fpti.record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.page,
          e: 'cl',
          link: `expand_${fileName}_${section}`,
        },
      })
    }
    if (gaData) {
      gaData('send', 'event', `expand_${fileName}_${section}`, 'click', {})
    }

    setIsOpen(true)
  }

  return (
    <>
      <div
        className={`imageContainer ${className}`}
        style={{
          backgroundImage: `url("${src}")`,
          backgroundColor: 'rgb(250, 248, 245)',
        }}
      >
        {/* <img className="imageContainerImage" src={src} /> */}
        <div className="imageContainerController">
          <ContextualAlert
            type="info"
            className="imageContainerAlert"
            style={{ color: 'white' }}
          >
            <p className="imageContainerCaption">{caption}</p>
          </ContextualAlert>
          <div className="imageContainerButtons">
            <IconButton Icon={DownloadButton} onClick={downloadImage} />
            <IconButton Icon={ExpandButton} onClick={expandImage} />
          </div>
        </div>
      </div>
      {isOpen && (
        <Lightbox onCloseRequest={() => setIsOpen(false)} mainSrc={src} />
      )}
    </>
  )
}

export default withAnalytics(ImageContainer)
